<script lang="ts">
  import type { RecommendationProduct } from "../../../interfaces/RecommendationProduct"

  import ExpertAvatar from "../../Expert/ExpertAvatar.svelte"
  import Card from "../../Common/Card.svelte"
  import Text from "../../Common/Text.svelte"

  export let product: RecommendationProduct
</script>

{#if product.message}
<Card class="expert-message-card">
  <ExpertAvatar />
  <Text class="expert-message">
    {@html product.message}
  </Text>
</Card>
{/if}
